import { gql } from '@apollo/client'

export const AppointmentFragment = gql`
  fragment Appointment on Appointment {
    id
    brand
    customerId
    createdAt
    externalMeetingProvider
    serviceProviderName
    storeId
    customerName
    customerAddress
    customerPostCode
    customerCity
    customerCountry
    customerEmail
    customerPhone
    selectedDate
    selectedTime
    selectedEndTime
    duration
    comment
    simplyBookMeId
    simplyBookMeStatus
    store {
      storeName
      address
    }
    onlineMeeting {
      id
      subject
      joinUrl
      joinMeetingId
    }
    appointmentPreparations {
      comment
      questions {
        question
        answers
      }
      currentKitchenImagesUrls
      willBringCurrentKitchenImages
      kitchenScetchImagesUrls
      willBringKitchenScetchImages
    }
    designerEmail
  }
`
